import React from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import { useTranslation } from 'react-i18next';

import Button from 'app/common/ui/Button';
import { eljurMakeLink } from 'app/actions/eljur/link';

// Время пока живет ссылка 10 мин. (linkAvailable на минуту меньше переод регенерации ссылки)
const linkAvailable = 540000;

// Кнопка перехода в Элжур !!! Перед ee показом должен быть сохранен токен. TODO перенести сюда эту проверку
// ссылка генерируется на сервере, поэтому токен должен быть сохранен на сервере

const enhance = compose(

  connect(
    state => ({
      loading: state.eljur.link.loading,
      link: state.eljur.link.link,
    }),
    dispatch => ({
      makeLink: async () => {
        await dispatch(eljurMakeLink());
      },
    })
  ),

  lifecycle({
    // $FlowFixMe
    UNSAFE_componentWillMount() {
      this.timer = setInterval(this.props.makeLink, linkAvailable);
    },
    componentDidMount() {
      this.props.makeLink();
    },
    componentWillUnmount() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
  })

);


type Props = {
  link: string,
  children?: any,
  className?: string,
};

const ElJurGoTo = ({ link, children, className }: Props) => {
  const { t } = useTranslation('eljur');

  return (
    <Button
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      disabled={!link}
    >
      {!link
        ? t('goto_eljur_bt_loading')
        : (children || t('goto_eljur_bt'))}
    </Button>
  );
};

export default enhance(ElJurGoTo);
